import Colors from 'enums/Colors';
import { Description } from 'pages/biblioteca_v2/components/categoria-item/DefaultItem.styled';
import { Container } from 'react-bootstrap';
import styled from 'styled-components';

const RolesFVStyled = {
    Container: styled.div`
        display: flex;
        flex-direction: column;
        gap: 16px;
    `,

    Title: styled.h1`
        font-family: 'Barlow';
        font-weight: 700;
        font-style: Bold;
        font-size: 40px;
        line-height: 150%;
        letter-spacing: -1%;
        vertical-align: middle;
        text-transform: uppercase;
    `,

    RowBetween: styled.div`
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 16px;
    `,

    CardRole: {
        Container: styled.div`
            display: flex;
            flex-direction: column;
            padding: 20px;
            gap: 16px;
            box-shadow: 10px 10px 5px -6px rgba(0, 0, 0, 0.17);
            -webkit-box-shadow: 10px 10px 5px -6px rgba(0, 0, 0, 0.17);
            -moz-box-shadow: 10px 10px 5px -6px rgba(0, 0, 0, 0.17);
        `,

        Title: styled.h2`
            font-family: 'Barlow';
            font-weight: 600;
            font-size: 26px;
        `,

        Description: styled.p`
            font-family: 'Barlow';
            font-size: 16px;
            color: ${Colors.Grey12};
        `,

        Banner: styled.img`
            width: 100%;
            height: 115px;
        
        `
    },

    NoRolesMessage: styled.p`
        font-family: 'Barlow';
        font-size: 16px;
        color: gray;
    `,
};

export default RolesFVStyled;
